module.exports = __webpack_public_path__ + "img/betflix-support.c43ccecb.png";